import LoopSlider from "./LoopSlider";
import Swiper from "swiper";
import {
	Pagination,
	Autoplay,
	Navigation,
	EffectFade,
	Thumbs,
	Scrollbar,
	Grid,
} from "swiper/modules";

$(document).ready(() => {
	const homeFeaturedProjectThumbnailSlider = new Swiper(
		".home-featured-project-thumbnail .swiper",
		{
			slidesPerView: 4.5,
			spaceBetween: 16,
			loop: true,
			breakpoints: {
				576: {
					slidesPerView: 4.5,
				},
				1024: {
					slidesPerView: 3,
				},
			},
		}
	);
	const homeFeaturedProjectSlider = new Swiper(
		".home-featured-project-slider .swiper",
		{
			modules: [Autoplay, EffectFade, Thumbs],
			effect: "fade",
			slidesPerView: 1,
			loop: true,
			autoplay: {
				delay: 4000,
				disableOnInteraction: false,
			},
			thumbs: {
				swiper: homeFeaturedProjectThumbnailSlider,
			},
		}
	);

	const waveSlider = new Swiper(".wave-slider .swiper", {
		modules: [Autoplay, Navigation],
		slidesPerView: 2.5,
		spaceBetween: 16,
		loop: true,
		speed: 4000,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		breakpoints: {
			768: {
				slidesPerView: 3.5,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 5,
				spaceBetween: 32,
			},
		},
	});

	const areaImageSlider = new Swiper(".area-image-slider .swiper", {
		slidesPerView: 1.15,
		spaceBetween: 16,
		modules: [Autoplay],
		centeredSlides: true,
		loop: true,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		breakpoints: {
			1024: {
				slidesPerView: 1.635,
				spaceBetween: 40,
			},
		},
	});

	const areaBenefitSlider = new Swiper(".area-benefit-slider .swiper", {
		slidesPerView: 1.25,
		spaceBetween: 16,
		modules: [Autoplay],
		loop: true,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		breakpoints: {
			1024: {
				slidesPerView: 2.25,
				spaceBetween: 24,
			},
		},
	});

	const certificateSlider = new Swiper(".certificate-slider .swiper", {
		modules: [Autoplay, Navigation, Pagination],
		slidesPerView: 1.15,
		spaceBetween: 16,
		loop: true,
		autoplay: { delay: 4000, disableOnInteraction: false },
		navigation: {
			nextEl: ".section-certificate .swiper-btn-next",
			prevEl: ".section-certificate .swiper-btn-prev",
		},
		pagination: {
			el: ".section-certificate .swiper-pagination",
			clickable: true,
			type: "progressbar",
		},
		centeredSlides: true,
		breakpoints: {
			768: {
				slidesPerView: 2.25,
				centeredSlides: false,
			},
			1024: {
				centeredSlides: false,
				slidesPerView: 3,
				spaceBetween: 40,
			},
		},
	});

	const historySlider = new Swiper(".history-slider .swiper", {
		modules: [Navigation],
		slidesPerView: 1.45,
		centeredSlides: true,
		spaceBetween: 16,
		navigation: {
			nextEl: ".history-slider .swiper-btn-next",
			prevEl: ".history-slider .swiper-btn-prev",
		},
		breakpoints: {
			576: {
				slidesPerView: 2.25,
			},
			768: {
				slidesPerView: 4.25,
				spaceBetween: 24,
				centeredSlides: false,
			},
			1024: {
				slidesPerView: 5,
				spaceBetween: 24,
				centeredSlides: false,
			},
		},
	});

	const homeBannerSlider = new Swiper(".home-banner-slider .swiper", {
		modules: [Autoplay, EffectFade, Pagination],
		slidesPerView: 1,
		loop: true,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		effect: "fade",
		pagination: {
			el: ".home-banner-slider .swiper-pagination",
			clickable: true,
		},
	});

	const singleSlider = new LoopSlider(".single-slider", {
		1024: {
			spaceBetween: 40,
			slidesPerView: 1,
		},
	});

	const doubleSlider = new LoopSlider(".double-slider", {
		576: {
			spaceBetween: 20,
			slidesPerView: 1.5,
		},
		1024: {
			spaceBetween: 40,
			slidesPerView: 2,
			centeredSlides: false,
		},
	});

	const tripleSlider = new LoopSlider(".triple-slider", {
		576: {
			spaceBetween: 20,
			slidesPerView: 2.5,
		},
		1024: {
			spaceBetween: 40,
			slidesPerView: 3,
			centeredSlides: false,
		},
	});

	const quadrupleSlider = new LoopSlider(".quadruple-slider", {
		576: {
			spaceBetween: 20,
			slidesPerView: 2.5,
		},
		768: {
			spaceBetween: 20,
			slidesPerView: 3.5,
		},
		1024: {
			spaceBetween: 40,
			slidesPerView: 4,
			centeredSlides: false,
		},
	});
});
